<template>
  <div>
    <div class="container-fluid pl-0 pr-0">

      <div class="info-bar-back">
        <template>
          <div
              style=" position: absolute; left: 0;   ">
            <div style="position:relative;left:10px;top:5px;font-size:15px;">
              {{ getCargo(this.$route.params.cargoId).reference }}
            </div>
            <!--          <div  v-if="cargoDetails.palletPlaces" style="position:relative;left:10px;top:0px; font-weight:500;font-size:13px;">{{ cargoDetails.palletPlaces.toFixed(1) }}</div>-->
          </div>
        </template>

        <a :to="{name:'loading'}" @click="$router.go(-1)" class="float-right">{{ $t('button.back') }}</a>
      </div>
      <div class="row ml-0 mr-0">
        <div class="col-12 pl-0 pr-0">
          <input type="text" name="search" id="search" placeholder="Search..." v-model="search" class=form-control
                 @keyup="search = $event.target.value">
        </div>
      </div>
      <div class="row ml-0 mr-0">

        <div class="col-12 pl-0 pr-0">
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
              <th>Aantal</th>
              <th>Barcode</th>
              <th>Zending</th>
              <th>Postcode</th>
              <th>Opdrachtgever</th>
              <th>Barcode onleesbaar</th>
              <th>Emballage</th>
              </thead>
              <tbody>
              <template v-for="(product,idx) in getUnfinishedUnloading">
                <v-touch :key="idx+1" :tag="'tr'" :style="getOpacity(product)"
                         @press="orderProductOptions('unloading',product,null)">
                  <td>{{ product.amountUnloaded ? product.amountUnloaded : 0 }} / {{ product.amount }}</td>
                  <td>{{ product.productNumber }}</td>
                  <td>{{ product.packingListNumber }}</td>
                  <td>{{ product.unloadingInformation.length ? product.unloadingInformation[1].value : "" }}</td>
                  <td>{{ product.unloadingInformation.length ? product.unloadingInformation[2].value : "" }}</td>
                  <td>{{ product.barcodeUnreadable ? "Onleesbaar" : "Leesbaar" }}</td>
                  <td>{{ product.unloadingInformation.length ? product.unloadingInformation[0].value : "" }}</td>

                </v-touch>
              </template>
              </tbody>

            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import CargoStatusIcon from '../../components/CargoStatusIcon';


export default {
  components: {
    CargoStatusIcon
  },
  data() {
    return {
      showDone: false,
      tooltip: true,
      currentTime: null,
      search: "",
      done: false
    };
  },
  computed: {
    ...mapGetters('incomingOrderProducts', ['getProducts']),
    ...mapGetters('incomingCargo', ['getCargo']),

    ...mapGetters(['getAPICompanyID']),
    getUnfinishedUnloading() {

      // eslint-disable-next-line no-undef
      let filtered = _.filter(this.getProducts, (product) => {

        if ((product.cargoId == this.$route.params.cargoId || product.cargoNumber == this.$route.params.cargoNumber )&& !product.retour && product.amount > 0) {
          return product;
        }
      });
      let search = this.search.toLowerCase()
      filtered = _.filter(filtered, product => {
        if (search.length) {
          return product.productNumber.toLowerCase().indexOf(search) >= 0 || JSON.stringify(product.unloadingInformation).toLowerCase().indexOf(search) >= 0
        } else {
          product.amountLeftToLoad = product.amount - product.amountUnloaded
          return product
        }
        // || _.some(product.unloadingInformation, search)
      })
      // eslint-disable-next-line no-undef
      return _.orderBy(filtered, ['barcodeUnreadable', 'amountLeftToLoad'], ['asc', 'desc']);
    }
  },
  methods: {
    getOpacity(product) {
      let opac = 1
      if (product.barcodeUnreadable || product.amountUnloaded >= product.amount) {
        opac = 0.5
      }

      return 'opacity:' + opac
    },
    getETA(timestamp) {
      if (timestamp) {
        // eslint-disable-next-line no-undef
        return moment(timestamp.toDate()).format('DD/MM/YY');
      } else {
        return '';
      }
    },
    checkETA(incoming) {
      let now = this.currentTime;
      if (now && incoming.estimatedTimeOfArrival)
          // eslint-disable-next-line no-undef
        return now.isAfter(moment(incoming.estimatedTimeOfArrival.toDate())) && incoming.status != 'done';
    },


  },
  watch: {
    search(newV) {
      localStorage.setItem('unloading-unloaded-overview', newV)
    }
  },
  async beforeRouteLeave(to, from, next) {

    if (this.done == true) {
      if (to.name !== 'teamlead-cargos-unloading') {
        await this.$store.dispatch('incomingOrderProducts/closeDBChannel');
      }
      next();
    }
  },
  async created() {
    // if (localStorage.getItem('unloading-unloaded-overview')) {
    //   this.search = localStorage.getItem('unloading-unloaded-overview')
    //
    // }
    this.$store.commit('setLoading', true)
    // let where = [
    //   ['companyId', '==', parseInt(this.getAPICompanyID)],
    //   ['cargoId', '==', this.$route.params.cargoId]
    //
    // ];

    // await this.$store.dispatch('incomingOrderProducts/openDBChannel', {where});
    this.$store.commit('setLoading', false)
    this.done = true
  }
};
</script>

<style lang="scss" scoped>

.row {
  padding-right: 0;
  padding-left: 0;
}
</style>